import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

export const ImagePreview = (props) => {

  var {sendPic, cancelPreview, previewImageDataUrl} = props;

  return previewImageDataUrl
            && previewImageDataUrl.length
            &&  <div style={ { zIndex: "3", backgroundColor: 'black' } } className="w-100 h-100 d-flex flex-column">
           <div style={ { backgroundColor: 'blue' } } className="w-100 flex-1">
             <img className="h-100" src={ previewImageDataUrl } />
           </div>
           <div className="d-flex w-100 m-3 justify-content-around" style={ { position: "absolute", bottom: "0", zIndex: "2", backgroundColor: 'transparent' } }>
             <Button onClick={ (event) => sendPic() } variant="contained" color="primary">
               Send Pic
             </Button>
             <Button onClick={ (event) => cancelPreview() } variant="contained" color="secondary">
               Cancel
             </Button>
           </div>
         </div>
}


// WEBPACK FOOTER //
// ./src/Components/JitsuCamponent/ImagePreview.js